import { render, staticRenderFns } from "./SearchOptionFuzzy.vue?vue&type=template&id=08f7b4ce"
import script from "./SearchOptionFuzzy.vue?vue&type=script&lang=js"
export * from "./SearchOptionFuzzy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports